// extracted by mini-css-extract-plugin
export var alt = "TemplateOffersList-module--alt--497b1";
export var container = "TemplateOffersList-module--container--61eb0";
export var desktopOnly = "TemplateOffersList-module--desktopOnly--bf639";
export var main = "TemplateOffersList-module--main--18fb8";
export var mobileOnly = "TemplateOffersList-module--mobileOnly--2c0d2";
export var styledRow = "TemplateOffersList-module--styledRow--cca4f";
export var textLeft = "TemplateOffersList-module--textLeft--274c8";
export var title = "TemplateOffersList-module--title--e7067";
export var visuallyHidden = "TemplateOffersList-module--visuallyHidden--1ae40";